import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ILog } from '../../../../utils/types/ILog';

interface LogDetailsProps {
    log: ILog;
    onClose?: () => void;
}

const LogDetailsContent: React.FC<LogDetailsProps> = ({ log }) => {
    return (
        <div className="card">
            <div className="card-body">
                <ul>
                    <li>Message : {log.message ?? ''}</li>
                    <li>Message Template : {log.messageTemplate ?? ''}</li>
                    <li>Level : {log.level ?? ''}</li>
                    <li>TimeStamp : {log.timeStamp?.toString() ?? ''}</li>
                    <li>Exception : {log.exception ?? ''}</li>
                    <li>Properties : {log.properties ?? ''}</li>
                </ul>
            </div>
        </div>
    );
};

const LogDetails: React.FC<LogDetailsProps> = ({ log, onClose }) => {
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => {
        setShowModal(false);
        onClose?.();
    };
    const handleShow = () => setShowModal(true);

    // ---

    return (
        <>
            <button
                onClick={handleShow}
                style={{
                    cursor: 'pointer',
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    color: '#0066cc',
                    textDecoration: 'underline',
                }}
            >
                Détails
            </button>

            <Modal show={showModal} onHide={handleClose} size="lg" scrollable backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Détails</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <LogDetailsContent log={log} />
                </Modal.Body>
            </Modal>
        </>
    );
};

export default LogDetails;
